import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';
import RootLayout from '../layout/RootLayout';
import BaseRouteHandler from './BaseRouteHandler';
import PrivateRouteHandler from './PrivateRouteHandler';

const ErrorHandler = lazy(() => import('../components/ErrorHandler'));
const AdminDashboard = lazy(() => import('../admin/AdminDashboard'));
const LogIn = lazy(() => import('../components/LogIn'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorHandler />,
    children: [
      {
        element: <BaseRouteHandler />,
        children: [
          {
            index: true,
            element: <LogIn />,
          },
          {
            path: '/login',
            element: <LogIn />,
          },
        ],
      },
      {
        element: <PrivateRouteHandler />,
        children: [
          {
            index: true,
            element: <AdminDashboard />,
          },
          {
            path: 'admin/*',
            element: <AdminDashboard />,
          },
          {
            path: '*',
            element: <AdminDashboard />,
          },
        ],
      },
    ],
  },
]);
